import { render, staticRenderFns } from "./Downline.vue?vue&type=template&id=f230532c&"
import script from "./Downline.vue?vue&type=script&lang=js&"
export * from "./Downline.vue?vue&type=script&lang=js&"
import style0 from "./Downline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports